import * as K from './CollectionsConstants';

export const init = {
    loading: false,
    loaded: false,
    search: '',
    data: [],
    searchData: null,
    table: {
        page: 0,
        sorted: [],
        filtered: [],
        pageSize: undefined
    },
    formData: {
        clientId: '',
        email: '',
        password: '',
        tipo: ''
    }
};

export default function reducer(state = init, action) {
    switch (action.type) {
        //GET CLIENTS

        case K.FIND + '_PENDING': {
            return { ...state, loading: true };
        }

        case K.FIND + '_FULFILLED': {
            return {
                ...state,
                loading: false,
                loaded: true,
                data: action.payload,
                formData: {}
            };
        }

        case K.FIND + '_REJECTED': {
            return {
                ...state,
                loading: false,
                loaded: false,
                data: [],
                formData: {},
                error: action.payload
            };
        }

        //GET CLIENT

        case K.FIND_BY_ID + '_PENDING': {
            return { ...state, loading: true };
        }

        case K.FIND_BY_ID + '_FULFILLED': {
            return {
                ...state,
                loading: false,
                loaded: true,
                formData: action.payload
            };
        }

        case K.FIND_BY_ID + '_REJECTED': {
            return {
                ...state,
                loading: false,
                loaded: false,
                formData: init.formData,
                error: action.payload
            };
        }

        //CREATE

        case K.CREATE + '_PENDING': {
            return { ...state, loading: true };
        }

        case K.CREATE + '_FULFILLED': {
            return {
                ...state,
                search: '',
                loading: false,
                loaded: true,
                formData: init.formData,
                openForm: false
            };
        }

        case K.CREATE + '_REJECTED': {
            return {
                ...state,
                loading: false,
                loaded: false,
                formData: init.formData,
                error: action.payload
            };
        }

        //UPADTE

        case K.UPDATE + '_PENDING': {
            return { ...state, loading: true, formData: action.payload };
        }

        case K.UPDATE + '_FULFILLED': {
            return {
                ...state,
                loading: false,
                loaded: true,
                formData: init.formData
            };
        }

        case K.UPDATE + '_REJECTED': {
            return {
                ...state,
                loading: false,
                loaded: false,
                formData: init.formData,
                error: action.payload
            };
        }

        //DELETE

        case K.DELETE + '_PENDING': {
            return { ...state, loading: true };
        }

        case K.DELETE + '_FULFILLED': {
            return {
                ...state,
                loading: false,
                loaded: true,
                formData: init.formData
            };
        }

        case K.DELETE + '_REJECTED': {
            return {
                ...state,
                loading: false,
                loaded: false,
                formData: init.formData,
                error: action.payload
            };
        }

        case K.CHANGE_TABLE: {
            return {
                ...state,
                table: {
                    ...state.table,
                    [action.payload.feature]: action.payload.value
                }
            };
        }

        case K.SEARCH_TABLE: {
            return {
                ...state,
                searchData:
                    action.payload.search !== ''
                        ? action.payload.searchData
                        : null,
                search: action.payload.search
            };
        }

        default:
            /* code */
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/views/Collections/redux/CollectionsReducers.jsx